package com.far.suller.components

import androidx.compose.runtime.*
import com.far.suller.models.Section
import com.far.suller.util.Constants.FONT_FAMILY
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

private val AMBER = Color.rgb(245, 158, 11)

@Composable
fun overflowMenu(onMenuClosed: () -> Unit) {
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    var translateX by remember { mutableStateOf((-100).percent) }
    var opacity by remember { mutableStateOf((0).percent) }

    LaunchedEffect(breakpoint) {
        translateX = 0.percent
        opacity = 100.percent
        if (breakpoint > Breakpoint.MD) {
            scope.launch {
                translateX = (-100).percent
                opacity = 0.percent
                delay(500)
                onMenuClosed()
            }
        }
    }

    // Full-screen dimmed backdrop — clicking it closes the drawer
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.vh)
            .position(Position.Fixed)
            .zIndex(2)
            .opacity(opacity)
            .backgroundColor(argb(a = 0.7f, r = 0.0f, g = 0.0f, b = 0.0f))
            .transition(Transition.of(property = "opacity", duration = 500.ms))
            .onClick {
                scope.launch {
                    translateX = (-100).percent
                    opacity = 0.percent
                    delay(500)
                    onMenuClosed()
                }
            },
    ) {
        // Slide-in drawer panel — stop clicks from bubbling to the backdrop
        Column(
            modifier = Modifier
                .fillMaxHeight()
                .padding(top = 96.px, bottom = 32.px, leftRight = 20.px)
                .width(
                    if (breakpoint < Breakpoint.MD) 70.percent else 25.percent,
                )
                .overflow(Overflow.Auto)
                .scrollBehavior(ScrollBehavior.Smooth)
                .styleModifier {
                    property(
                        "background",
                        "linear-gradient(160deg, #0F0700 0%, #1A0A00 60%, #2c1910 100%)",
                    )
                    property("border-right", "1px solid rgba(245, 158, 11, 0.2)")
                    property("box-shadow", "8px 0 40px rgba(0,0,0,0.6)")
                }
                .translateX(tx = translateX)
                .transition(Transition.of(property = "translate", duration = 500.ms))
                .onClick { it.stopPropagation() },
        ) {
            // ── Amber divider line ────────────────────────────────────────
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(1.px)
                    .backgroundColor(Color.rgba(245, 158, 11, 0.2f))
                    .margin(bottom = 28.px),
            )

            // ── Nav links — same 8 as the desktop header ──────────────────
            Section.entries.toTypedArray().take(8).forEach { section ->
                Link(
                    modifier = Modifier
                        .margin(bottom = 8.px)
                        .fillMaxWidth()
                        .padding(leftRight = 16.px, topBottom = 14.px)
                        .borderRadius(10.px)
                        .fontFamily(FONT_FAMILY)
                        .fontSize(16.px)
                        .fontWeight(FontWeight.SemiBold)
                        .color(Colors.White)
                        .textDecorationLine(TextDecorationLine.None)
                        .styleModifier {
                            property("border", "1px solid rgba(245,158,11,0.08)")
                            property("background", "rgba(245,158,11,0.04)")
                            property("transition", "all 0.2s ease")
                            property("letter-spacing", "0.5px")
                        }
                        .onClick {
                            scope.launch {
                                translateX = (-100).percent
                                opacity = 0.percent
                                delay(500)
                                onMenuClosed()
                            }
                        },
                    path = section.path,
                    text = section.title,
                    openInternalLinksStrategy = OpenLinkStrategy.IN_PLACE,
                )
            }

            // ── Bottom accent ─────────────────────────────────────────────
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(1.px)
                    .backgroundColor(Color.rgba(245, 158, 11, 0.2f))
                    .margin(top = 24.px, bottom = 20.px),
            )
            P(
                attrs = Modifier
                    .fontFamily(FONT_FAMILY)
                    .fontSize(11.px)
                    .color(Color.rgba(245, 158, 11, 0.4f))
                    .styleModifier { property("letter-spacing", "2px") }
                    .toAttrs(),
            ) { Text("farsuller.com") }
        }
    }
}
